import { useAppDispatch } from 'app/store';
import { TenantPage } from 'components/common';
import { loadingActions } from 'features';
import { ITenantSettings } from 'interfaces';
import { useSnackbar } from 'notistack';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { tenantSettingsService } from 'services/api';
import TenantSettingsForm from '../TenantSettingsForm';
import { Button } from '@mui/material';
import { useNavigate } from 'react-router-dom';

export const TenantSettings = () => {
  const { t } = useTranslation();
  const translationPrefix = 'pages.tenant-settings.edit';
  const navigate = useNavigate();

  const [tenantSettings, setTenantSettings] = useState<ITenantSettings>();

  const { enqueueSnackbar } = useSnackbar();
  const dispatch = useAppDispatch();

  const updateSettings = async (values) => {
    dispatch(loadingActions.startLoading());
    tenantSettingsService.update(1, values).then(() => {
      enqueueSnackbar('Impostazioni salvate con successo', { variant: 'success' });
    });
    dispatch(loadingActions.stopLoading());
  };

  useEffect(() => {
    tenantSettingsService.get(1).then(setTenantSettings);
  }, []);

  return (
    <TenantPage
      title={t(`${translationPrefix}.title`)}
      subtitle={t(`${translationPrefix}.subtitle`)}
      menuRight={
        <div>
          <Button color="primary" onClick={() => navigate('sap')}>
            {t('entities.tenant-settings.sap')}
          </Button>
        </div>
      }>
      <TenantSettingsForm tenantSettings={tenantSettings} onSubmit={updateSettings} />
    </TenantPage>
  );
};

export default TenantSettings;
